import { CashierContentBalanceAmountStyled, CashierContentBalanceTitleStyled } from "./styled/CashierStyled";
import amountFormat from "../../utils/amountFormat";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext";

function CashierWithdrawalAmount(props) {
    const {amount} = props;
    const {getLangPath} = useLangContext();
    return <>
        <CashierContentBalanceTitleStyled className="mt-2">
            {getLangPath('menu.withdrawal_funds')}
        </CashierContentBalanceTitleStyled>
        <CashierContentBalanceAmountStyled>
            ${amountFormat(amount)}
        </CashierContentBalanceAmountStyled>
    </>
}

export default CashierWithdrawalAmount;
